import classes from './Manual.module.css'
import React from 'react'
import GoButton from '../components/GoButton'
import Header from '../components/Header'
import Settings from '../settings/Settings'


const Manual = props => {
    return (
        <>
            {props.showSettings && <Settings onClose={props.onClose} sound={props.sound} soundOnOff={props.soundOnOff} />}
            <Header title="Manual" onClose={props.onClose} />
            <div className={classes.manual}>
                <div className={classes.text}>
                    <span className={classes.titlebold}>Are you fluent at English?</span>
                    <p><span className={classes.titleapp}>Drilleng</span> is going to help you to develop a good understanding of English sentence structure on a deep level.</p>
                    <span className={classes.titlebold}>How it works?</span>
                    <p>You will be asked simple yes-or-no questions, on which you are supposed to give a full sentence answer based on the question. Positive or negative it doesn’t matter! For example: Does your mom love chocolate? You should say: Yes, my mom loves chocolate. Or: No, my mom doesn’t love chocolate.</p>
                    <p>All questions are generated randomly based on predefined data. The app does also provide you with correct answers in both positive and negative form, so you could check you answer and learn on the fly.</p>
                    <span className={classes.titlebold}>Are you ready?</span>
                    <span className={classes.titlebold}>Press Go to begin!</span>
                </div>
                <GoButton />
            </div>

        </>
    )
}

export default Manual